module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    ref: "top"
  }, [(_vm.baseInfo != null) ? _c('headerTop', {
    attrs: {
      "baseInfo": _vm.baseInfo,
      "englishpc": _vm.englishpc,
      "isregister": _vm.isregister
    }
  }) : _vm._e(), _vm._v(" "), _c('i-header', {
    attrs: {
      "slides": _vm.slides,
      "banner": _vm.template.tmpImg
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "nav"
  }, _vm._l((_vm.template.navs), function(nav, i) {
    return (_vm.template && _vm.template.navs.length > 0 && nav.navType != 6) ? _c('li', {
      key: i,
      staticClass: "nav1",
      class: {
        active: _vm.activeNav === i ? true : false
      },
      on: {
        "mouseover": function($event) {
          _vm.mouseoverNav(i)
        },
        "mouseout": function($event) {
          _vm.mouseoutNav(i)
        },
        "click": function($event) {
          _vm.clickNav(nav, i)
        }
      }
    }, [(nav.navType != 3) ? _c('span', {
      ref: "navSpan",
      refInFor: true,
      style: ({
        color: _vm.activeNav === i ? _vm.color : '#333'
      })
    }, [_vm._v(_vm._s(nav.navName))]) : _vm._e(), _vm._v(" "), (nav.navType == 3) ? _c('span', {
      ref: "navSpan",
      refInFor: true,
      style: ({
        color: _vm.activeNav === i ? _vm.color : '#333'
      })
    }, [_c('a', {
      staticClass: "out-link",
      attrs: {
        "target": "_blank",
        "href": nav.navUrl
      }
    }, [_vm._v(_vm._s(nav.navName))])]) : _vm._e(), _vm._v(" "), (nav.comps.length > 1) ? _c('ul', {
      staticClass: "nav2"
    }, _vm._l((nav.comps), function(item, j) {
      return _c('li', {
        key: j,
        class: {
          active: item.activeId == (_vm.activeNav + '-' + _vm.activeNav2) ? true : false
        },
        style: ({
          color: item.activeId == (_vm.activeNav + '-' + _vm.activeNav2) ? _vm.color : '#333'
        }),
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.setNav2(i, j, nav)
          },
          "mouseover": _vm.mouseoverNav1,
          "mouseout": _vm.mouseoutNav1
        }
      }, [_vm._v("\n            " + _vm._s(item.cpnTitle) + "\n          ")])
    })) : _vm._e()]) : _vm._e()
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "contain clear"
  }, [_c('div', {
    ref: "container",
    staticClass: "c-left left",
    staticStyle: {
      "min-height": "1px",
      "overflow": "hidden"
    }
  }, [(_vm.template) ? _c('rcom', {
    attrs: {
      "activeNav": _vm.activeNav,
      "color": _vm.color,
      "currentNavCon": _vm.currentNavCon
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    ref: "action",
    staticClass: "c-right left"
  }, [_c('div', {
    staticClass: "contain-box"
  }, [(_vm.baseInfo) ? _c('ul', {
    staticClass: "zhuce-box"
  }, [_c('li', {
    directives: [{
      name: "touch-ripple",
      rawName: "v-touch-ripple"
    }],
    class: {
      cursor: _vm.baseInfo.registerfl, cursor1: _vm.baseInfo.registerFl == 0
    },
    staticStyle: {
      "background-color": "#f4b47f"
    },
    on: {
      "click": function($event) {
        _vm.login()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/login1.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('message.tpl1.menu.register')))])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "touch-ripple",
      rawName: "v-touch-ripple"
    }],
    class: {
      cursor: _vm.baseInfo.groupRegisterFl == 1, cursor1: _vm.baseInfo.groupRegisterFl == 0
    },
    staticStyle: {
      "background-color": "#81C16A"
    },
    on: {
      "click": _vm.teamReg
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/login2.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('message.tpl1.menu.teamReg')))])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "touch-ripple",
      rawName: "v-touch-ripple"
    }],
    class: {
      cursor: _vm.baseInfo.paperSubmitFl == 1, cursor1: _vm.baseInfo.paperSubmitFl == 0
    },
    staticStyle: {
      "background-color": "#EA69A2"
    },
    on: {
      "click": _vm.reg1
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/login3.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('message.tpl1.menu.paperRegister')))])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "touch-ripple",
      rawName: "v-touch-ripple"
    }],
    class: {
      cursor: _vm.baseInfo.hotelBookFl == 1, cursor1: _vm.baseInfo.hotelBookFl == 0
    },
    staticStyle: {
      "background-color": "#88acd9"
    },
    on: {
      "click": function($event) {
        _vm.hotelBook()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/login4.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('message.tpl1.menu.hotelBook')))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "kaimu"
  }, [(_vm.isShowTime) ? _c('div', {
    staticClass: "title",
    staticStyle: {
      "color": "#333"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-daojishi",
    staticStyle: {
      "font-size": "25px",
      "margin-right": "12px"
    },
    style: ({
      color: _vm.color
    })
  }), _vm._v("\n              " + _vm._s(_vm.$t("message.tpl3.menu.daysDistance")) + " "), (_vm.baseInfo) ? _c('span', {
    staticClass: "light",
    staticStyle: {
      "font-size": "25px"
    },
    style: ({
      color: _vm.color
    })
  }, [_vm._v(_vm._s(_vm._f("diffDays")(_vm.baseInfo.cStartDt)))]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("message.tpl3.menu.day")))])]) : _vm._e(), _vm._v(" "), (_vm.baseInfo) ? _c('ul', {
    staticClass: "kaimu-time"
  }, [(_vm.baseInfo.cStartDt && _vm.baseInfo.cEndDt) ? _c('li', [_c('span', {
    staticClass: "label-time"
  }, [_vm._v(_vm._s(_vm.$t("message.tpl3.menu.mettingDate")))]), _vm._v(" "), _c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.baseInfo.cStartDt) + " "), _c('span', {
    staticStyle: {
      "margin-left": "5px",
      "margin-right": "5px"
    }
  }, [_vm._v(" " + _vm._s(_vm.language === 'en' ? 'to' : '-') + " ")]), _vm._v(" " + _vm._s(_vm.baseInfo.cEndDt))])]) : _vm._e(), _vm._v(" "), (_vm.baseInfo.cfgApplyEnd && _vm.baseInfo.cfgApplyEnd.length > 0) ? _c('li', [_c('span', {
    staticClass: "label-time"
  }, [_vm._v(_vm._s(_vm.$t("message.tpl3.menu.registerEndDate")))]), _vm._v(" "), _c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.baseInfo.cfgApplyEnd))])]) : _vm._e(), _vm._v(" "), (_vm.baseInfo.cSpotRegisterStart && _vm.baseInfo.cSpotRegisterStart.length > 0) ? _c('li', [_c('span', {
    staticClass: "label-time"
  }, [_vm._v(_vm._s(_vm.$t("message.tpl3.menu.reportDate")))]), _vm._v(" "), _c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.baseInfo.cSpotRegisterStart))])]) : _vm._e(), _vm._v(" "), (_vm.baseInfo.cPaperSubmitEndDt && _vm.baseInfo.cPaperSubmitEndDt.length > 0) ? _c('li', [_c('span', {
    staticClass: "label-time"
  }, [_vm._v(_vm._s(_vm.$t("message.tpl3.menu.paperEndDate")))]), _vm._v(" "), _c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.baseInfo.cPaperSubmitEndDt))])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "link-us"
  }, [_c('div', {
    staticClass: "title",
    style: ({
      color: _vm.color
    })
  }, [_c('p', [_c('i', {
    staticClass: "iconfont icon-lianxiwomen",
    staticStyle: {
      "font-size": "16px",
      "margin-right": "12px"
    }
  }), _vm._v(_vm._s(_vm.$t("message.tpl3.menu.linkUs")))])]), _vm._v(" "), _c('div', {
    staticClass: "link-us-contain clear"
  }, [_c('div', {
    staticClass: "v-html",
    domProps: {
      "innerHTML": _vm._s(_vm.linkData.cpnContent)
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "70px",
      "font-size": "0"
    }
  }, [(_vm.tmpBottomImg) ? _c('img', {
    attrs: {
      "src": _vm.tmpBottomImg,
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('login', {
    attrs: {
      "color": _vm.color,
      "showBox": _vm.showBox
    },
    on: {
      "close": _vm.login2
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b40458e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tpl3/tpl3.vue
// module id = 798
// module chunks = 10